import { IconContainer } from '@/components/IconContainer'
import { Avatar } from '@/components/Avatar'
import { DropdownMenu } from '@/components/DropdownMenu'
import { More } from '@/components/More'
import { MemberExtended } from '@/types'

import s from './MemberItem.module.css'

type Props = {
  member: MemberExtended
  isMe: boolean
  onRemove: (id: string) => void
}

export const MemberItem = ({ member, isMe, onRemove }: Props) => {
  return (
    <div className={s.item} key={member.id}>
      <IconContainer size="lg">
        <Avatar src={member.image} name={member.name} />
      </IconContainer>
      <span className={s.text}>
        <b>
          {member.name} {isMe ? '(You)' : ''}
        </b>
        <div className={s.email}>{member.email}</div>
        <input type="hidden" name="shareWith" value={member.email} />
      </span>
      {!isMe && (
        <DropdownMenu>
          <DropdownMenu.Trigger>
            <More />
          </DropdownMenu.Trigger>
          <DropdownMenu.Content>
            <DropdownMenu.Item onClick={() => onRemove(member.id)} destructive>
              {member.invitationId ? 'Cancel Invitation' : 'Remove'}
            </DropdownMenu.Item>
          </DropdownMenu.Content>
        </DropdownMenu>
      )}
    </div>
  )
}
